import { createSlice } from '@reduxjs/toolkit'
import { HOME_SECTION_TYPE } from '../../pages/home-enterprise/components/sections/home-sections'
import name from './name'

const initialState = {
  isLoading: true,
  shouldLoad: true,
  sections: []
}

export const home = createSlice({
  name,
  initialState,
  reducers: {
    setHomePageSections: (state, { payload }) => {
      state.sections = payload
      state.isLoading = false
      state.shouldLoad = false
    },
    setMsbCourseProgress: (state, { payload }) => {
      state.sections = state.sections.map(section => {
        if (section.type === HOME_SECTION_TYPE.MSB) {
          return {
            ...section,
            data: {
              ...section.data,
              skills: section.data.skills.map(skill => {
                return {
                  ...skill,
                  items: skill.items.map(item => {
                    if (item.id === payload.courseId) {
                      return {
                        ...item,
                        userProgress: payload
                      }
                    }
                    return item
                  })
                }
              })
            }
          }
        }
        return section
      })
    },
    resetLoading: (state) => {
      state.isLoading = true
      state.shouldLoad = true
    }
  }
})

export const { setHomePageSections, resetLoading, setMsbCourseProgress } = home.actions

export default home.reducer
